import API, { handleRequest } from '@/api/lib/api'

export const getRevenueReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/revenue-report?${query}`
      : `restaurant/${id}/revenue-report`

    return API.get(endpoint)
  })

export const getEmployeeAnalysis = (id, params) =>
  handleRequest(() => API.get(`restaurant/${id}/employee-analysis`, params))

export const getMenuReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/menu-report?${query}`
      : `restaurant/${id}/menu-report`

    return API.get(endpoint)
  })

export const getCallLogsReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/call-log-report?${query}`
      : `restaurant/${id}/call-log-report`

    return API.get(endpoint)
  })

export const getLoyaltyReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/loyalty-report?${query}`
      : `restaurant/${id}/loyalty-report`

    return API.get(endpoint)
  })

export const getTableReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/table-report?${query}`
      : `restaurant/${id}/table-report`

    return API.get(endpoint)
  })

export const getReservationReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/reservation-report?${query}`
      : `restaurant/${id}/reservation-report`

    return API.get(endpoint)
  })

export const getOrderReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/order-report?${query}`
      : `restaurant/${id}/order-report`

    return API.get(endpoint)
  })

export const getOverviewReport = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/overview-report?${query}`
      : `restaurant/${id}/overview-report`

    return API.get(endpoint)
  })

export const getOfferReports = (id, params) =>
  handleRequest(() => {
    const query = new URLSearchParams(params || {}).toString()
    const endpoint = query
      ? `restaurant/${id}/offer-report?${query}`
      : `restaurant/${id}/offer-report`

    return API.get(endpoint)
  })

